export default {
  GET_USER_TOKEN: 'GET_USER_TOKEN',
  GET_USER_TOKEN_SUCCESS: 'GET_USER_TOKEN_SUCCESS',
  GET_USER_TOKEN_ERROR: 'GET_USER_TOKEN_ERROR',
  GET_USER_MAIL: 'GET_USER_MAIL',
  GET_USER_MAIL_SUCCESS: 'GET_USER_MAIL_SUCCESS',
  GET_USER_MAIL_ERROR: 'GET_USER_MAIL_ERROR',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_REQUEST_LOADING: 'LOGIN_REQUEST_LOADING',
  LOGIN_REQUEST_SUCCESS: 'LOGIN_REQUEST_SUCCESS',
  LOGIN_REQUEST_ERROR: 'LOGIN_REQUEST_ERROR',
  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT_REQUEST_SUCCESS: 'LOGOUT_REQUEST_SUCCESS',
  LOGOUT_REQUEST_ERROR: 'LOGOUT_REQUEST_ERROR',
  CLEAN_USER_TOKEN: 'CLEAN_USER_TOKEN',
  CLEAN_USER_TOKEN_SUCCESS: 'CLEAN_USER_TOKEN_SUCCESS',
  CLEAN_USER_TOKEN_ERROR: 'CLEAN_USER_TOKEN_ERROR',
  CLEAN_USER_MAIL: 'CLEAN_USER_MAIL',
  CLEAN_USER_MAIL_SUCCESS: 'CLEAN_USER_MAIL_SUCCESS',
  CLEAN_USER_MAIL_ERROR: 'CLEAN_USER_MAIL_ERROR',
  CLEAN_USER_SELECTED_ACCOUNTS: 'CLEAN_USER_SELECTED_ACCOUNTS',
  CLEAN_USER_SELECTED_ACCOUNTS_SUCCESS: 'CLEAN_USER_SELECTED_ACCOUNTS_SUCCESS',
  CLEAN_USER_SELECTED_ACCOUNTS_ERROR: 'CLEAN_USER_SELECTED_ACCOUNTS_ERROR',
  REGISTRATION_REQUEST: 'REGISTRATION_REQUEST',
  REGISTRATION_REQUEST_LOADING: 'REGISTRATION_REQUEST_LOADING',
  REGISTRATION_SUCCESS: 'REGISTRATION_SUCCESS',
  REGISTRATION_ERROR: 'REGISTRATION_ERROR',
  REGISTRATION_CLEAR: 'REGISTRATION_CLEAR',
  RECOVER_PASSWORD_REQUEST: 'RECOVER_PASSWORD_REQUEST',
  RECOVER_PASSWORD_LOADING: 'RECOVER_PASSWORD_LOADING',
  RECOVER_PASSWORD_SUCCESS: 'RECOVER_PASSWORD_SUCCESS',
  RECOVER_PASSWORD_ERROR: 'RECOVER_PASSWORD_ERROR',
  RECOVER_PASSWORD_CLEAR: 'RECOVER_PASSWORD_CLEAR',
  RENEW_PASSWORD_REQUEST: 'RENEW_PASSWORD_REQUEST',
  RENEW_PASSWORD_LOADING: 'RENEW_PASSWORD_LOADING',
  RENEW_PASSWORD_SUCCESS: 'RENEW_PASSWORD_SUCCESS',
  RENEW_PASSWORD_ERROR: 'RENEW_PASSWORD_ERROR',
  RENEW_PASSWORD_CLEAR: 'RENEW_PASSWORD_CLEAR',
};



// WEBPACK FOOTER //
// ./src/constants/auth/authTypes.js